import Vue from 'vue'
import * as apiService from 'API/delivery'
import { deepClone } from 'Utils/functions'
import { notifySuccess, notifyError } from 'Utils/notify'

const emptyPickup = {
  shopId: '',
  optionId: '',
  cancelInterval: '',
  intervals: []
}

const emptyInterval = {
  isEnabled: false,
  from: '',
  to: '',
  blockInterval: '',
  days: [
    {
      label: 'Пн',
      isEnabled: false,
      limit: ''
    },
    {
      label: 'Вт',
      isEnabled: false,
      limit: ''
    },
    {
      label: 'Ср',
      isEnabled: false,
      limit: ''
    },
    {
      label: 'Чт',
      isEnabled: false,
      limit: ''
    },
    {
      label: 'Пт',
      isEnabled: false,
      limit: ''
    },
    {
      label: 'Сб',
      isEnabled: false,
      limit: ''
    },
    {
      label: 'Вс',
      isEnabled: false,
      limit: ''
    }
  ]
}

export default {
  namespaced: true,
  state: () => ({
    pickup: deepClone(emptyPickup)
  }),
  getters: {
    deserializePickup: (state, getters) => (pickup) => ({
      shopId: pickup.shop_id,
      optionId: pickup.id,
      cancelInterval: pickup.expire_offset,
      intervals: pickup.interval.map(getters.deserializeInterval)
    }),
    serializeOption: (state) => () => ({
      optionId: state.pickup.optionId,
      expire_offset: +state.pickup.cancelInterval
    }),
    serializeIntervals: (state, getters) => () => ({
      pickup_option_id: state.pickup.optionId,
      intervals: state.pickup.intervals.map(getters.serializeInterval)
    }),
    serializeInterval: (state, getters) => (interval) => ({
      available_from: interval.from,
      available_to: interval.to,
      is_active: interval.isEnabled,
      blocking_for: +interval.blockInterval,
      daily_restrictions: interval.days.map(getters.serializeDay)
    }),
    serializeDay: (state, getters) => (day) => ({
      code: getters.getDayCode(day.label),
      is_active: day.isEnabled,
      max_count_of_orders: +day.limit
    }),
    getDayCode: () => (dayLabel) => {
      switch (dayLabel) {
        case 'Пн':
          return 'monday'
        case 'Вт':
          return 'tuesday'
        case 'Ср':
          return 'wednesday'
        case 'Чт':
          return 'thursday'
        case 'Пт':
          return 'friday'
        case 'Сб':
          return 'saturday'
        case 'Вс':
          return 'sunday'
        default:
          return ''
      }
    },
    deserializeInterval: (state, getters) => (interval) => ({
      isEnabled: interval.is_active,
      from: interval.available_from,
      to: interval.available_to,
      blockInterval: interval.blocking_for,
      days: interval.daily_restrictions.map(getters.deserializeDay)
    }),
    deserializeDay: (state, getters) => (day) => ({
      label: getters.deserializeDayCode(day.code),
      isEnabled: day.is_active,
      limit: day.max_count_of_orders
    }),
    deserializeDayCode: () => (dayCode) => {
      switch (dayCode) {
        case 'monday':
          return 'Пн'
        case 'tuesday':
          return 'Вт'
        case 'wednesday':
          return 'Ср'
        case 'thursday':
          return 'Чт'
        case 'friday':
          return 'Пт'
        case 'saturday':
          return 'Сб'
        case 'sunday':
          return 'Вс'
        default:
          return ''
      }
    }
  },
  actions: {
    async getPickups({ commit, getters }, storeId) {
      try {
        let { data } = await apiService.getPickupByStoreId(storeId)
        // У магазина по умолчанию вообще нет никаких "опций самовывоза",
        // поэтому перед работой создаём одну.
        if (data.length === 0) {
          await apiService.createOption(storeId)
          data = await apiService.getPickupByStoreId(storeId)
        }
        // На бэке у магазина может быть бесконечное количество "опций самовывоза",
        // а мы работаем только с одной
        commit('setPickup', getters.deserializePickup(data[0]))
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async submitPickup({ getters }) {
      try {
        await apiService.updateOption(getters.serializeOption())
        await apiService.updatePickupIntervals(getters.serializeIntervals())
        notifySuccess('Самовывоз успешно сохранён')
      } catch (e) {
        console.error(e)
        notifyError(e.response?.data?.error)
        throw e
      }
    }
  },
  mutations: {
    setPickup(state, pickup) {
      Vue.set(state, 'pickup', deepClone(pickup))
    },
    updatePickup(state, patch) {
      Vue.set(state, 'pickup', {
        ...state.pickup,
        ...patch
      })
    },
    updateInterval(state, patch) {
      state.pickup.intervals.splice(patch.index, 1, {
        ...state.pickup.intervals[patch.index],
        ...patch.value
      })
    },
    updateDay(state, patch) {
      state.pickup.intervals[patch.intervalIndex].days.splice(patch.index, 1, {
        ...state.pickup.intervals[patch.intervalIndex].days[patch.index],
        ...patch.value
      })
    },
    addInterval(state) {
      state.pickup.intervals.push(deepClone(emptyInterval))
    },
    removeInterval(state, index) {
      state.pickup.intervals.splice(index, 1)
    }
  }
}
